import ColumnSet from '@/components/grid/columns/column-set';
import ColumnsDefinitions from '@/common/definitions/columns/webhooks-logs';

export default function createColumns(expandData, resendWebhook) {
    return new ColumnSet({
        id: 'webhook-tracking-logs-list',
        ...ColumnsDefinitions(expandData, resendWebhook),
    });
}
